import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Field from 'src/components/ResumeCard/Body/Field';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { TagName } from 'src/models/candidatesList';
import { MessageTypes, UserType } from 'src/models/employer/resume/pinnedChatMessages';

import styles from './last-question.less';

const TrlKeys = {
    title: 'resume.search.field.lastQuestion',
};

interface LastQuestionProps {
    chatId?: number;
    topicId?: string;
}

const LastQuestion: TranslatedComponent<LastQuestionProps> = ({ chatId, topicId, trls }) => {
    const lastMessage = useSelector((state) =>
        chatId ? state.candidatesList?.chatsByIds?.chats[chatId]?.lastMessage : undefined
    );
    const candidateTags = useSelector((state) =>
        topicId ? state.candidatesList?.candidateTags?.tagsByTopicIds?.[topicId]?.tags : undefined
    );

    const hasQuestion = candidateTags?.some((tag) => tag.type === TagName.ApplicantQuestion);

    if (
        !hasQuestion ||
        lastMessage?.participant?.type !== UserType.ApplicantUser ||
        lastMessage?.type !== MessageTypes.Simple ||
        !lastMessage?.text
    ) {
        return null;
    }

    return (
        <Field title={trls[TrlKeys.title]} dataQaName="last-question">
            <span className={styles.lastQuestion}>{lastMessage.text}</span>
        </Field>
    );
};

export default translation(LastQuestion);
